import { reviewsData } from '@/components/utils/Constant';
import Image from 'next/image';
import React from 'react';
import star from '../../../../public/svg/review-on-site/star.svg';

const Review = () => {
  return (
    <div className="rounded-bl-2xl rounded-tr-2xl border border-glassWhite p-2 lg:p-3 xl:rounded-bl-3xl xl:rounded-tr-3xl xxl:p-6">
      <div className="no-scrollbar flex w-full flex-nowrap items-center gap-5 overflow-x-auto">
        {reviewsData.map((item, index) => (
          <div
            key={index}
            className="flex w-[344px] min-w-[200px] items-center justify-between gap-5"
          >
            <div>
              <Image
                src={item?.siteIcon}
                alt={item?.siteIcon}
                width={160}
                height={45}
              />
            </div>
            <div className="flex items-center gap-5">
              <div className="flex items-center gap-1.5">
                <Image src={star} alt="star" width={15} height={14} />
                <span className="font-opt text-base font-semibold leading-5 text-white">
                  {item?.review}
                </span>
              </div>
              {index !== reviewsData?.length - 1 && (
                <span className="h-7 w-0.5 bg-glassWhite"></span>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Review;
